export function isRoleAccessPathAllowed(useraccess, name, path) {
    if (!useraccess) return false;
    let access = useraccess.find(access=>access.accessname == name && access.accesspath == path);
    if (!access) return false;
    else if (!access.accessenabled) return false;
    else return true;
}

export const RoleAccessMixin = {
    methods: {
        isRoleAccessPathAllowed
    }
};
